export default [
  {
    key: 'emp_station_view_view',
    zh_CN: '电站视图',
    en: 'Power station view',
    de: 'Kraftwerksansicht',
    fr: 'Vue de la centrale électrique',
    ja: '発電所ビュー'
  },
  {
    key: 'emp_no_chart_data',
    zh_CN: '暂无数据',
    en: 'No data',
    de: 'Keine Daten',
    fr: 'Auc. data',
    ja: 'データがありません'
  },
  {
    key: 'emp_data_abnormal',
    zh_CN: '数据异常',
    en: 'Data abnormal',
    de: 'Abnormale Daten',
    fr: 'Data anormale',
    ja: 'データ異常'
  }
]
